module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Weather/Cloud-wind-83d03c80dddbe1fc15fae59a613d1f7e.svg";